export default class TabRotaUtils {
	titulo
	rota
	permissao = ''
	key = ''

	constructor(titulo, rota, permissao, key) {
		this.titulo = titulo
		this.rota = { name: rota }
		this.permissao = permissao
		this.key = key
	}
}
